import { render, staticRenderFns } from "./BottomBannerOne.vue?vue&type=template&id=fc38c4dc"
import script from "./BottomBannerOne.vue?vue&type=script&lang=js"
export * from "./BottomBannerOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports